import React, { useContext, useState } from "react";
import {
  Button,
  Label,
  Table,
  Confirm,
  Container,
  Tab,
  Menu,
} from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import TransmissionStore from "../../../app/stores/transmissionStore";
import { Link } from "react-router-dom";

const TransmissionList: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [transmissionId, setTransmissionId] = useState("");
  const transmissionStore = useContext(TransmissionStore);
  const {
    transmissionsByDate: transmissionsByDate,
    deleteTransmission: deleteTransmission,
    setActiveListTab,
    activeListTab,
    submitting,
    target,
  } = transmissionStore;

  const status = [
    "PO",
    "Scheduled",
    "Onhold",
    "HOP",
    "Invoice",
    "Complete",
    "Closed",
  ];

  // var countOfPO = transmissionsByDate.filter(x => {
  //   return x.status === "PO"
  //   }).length
  let countOfPO = 0;
  let countOfScheduled = 0;
  let countOfOnhold = 0;
  let countOfHOP = 0;
  let countOfInvoice = 0;
  let countOfComplete = 0;
  let countOfClosed = 0;
  transmissionsByDate.map(trans => {
    if (trans.status === 'PO') countOfPO ++; 
    if (trans.status === 'Scheduled') countOfScheduled ++; 
    if (trans.status === 'Onhold') countOfOnhold ++; 
    if (trans.status === 'HOP') countOfHOP ++; 
    if (trans.status === 'Invoice') countOfInvoice ++; 
    if (trans.status === 'Complete') countOfComplete ++; 
    if (trans.status === 'Closed') countOfClosed ++; 
  })

  const panes = status.map((stat) => {
    return {
    menuItem: ( (stat === 'PO') ? <Menu.Item><strong style={{color: 'purple'}}>PO</strong><Label>{countOfPO}</Label></Menu.Item> : 
                (stat === 'Scheduled') ? <Menu.Item><strong style={{color: 'purple'}}>Scheduled</strong><Label>{countOfScheduled}</Label></Menu.Item> : 
                (stat === 'Onhold') ? <Menu.Item><strong style={{color: 'purple'}}>Onhold</strong><Label>{countOfOnhold}</Label></Menu.Item> : 
                (stat === 'HOP') ? <Menu.Item><strong style={{color: 'purple'}}>HOP</strong><Label>{countOfHOP}</Label></Menu.Item> : 
                (stat === 'Invoice') ? <Menu.Item><strong style={{color: 'purple'}}>Invoice</strong><Label>{countOfInvoice}</Label></Menu.Item> : 
                (stat === 'Complete') ? <Menu.Item><strong style={{color: 'purple'}}>Complete</strong><Label>{countOfComplete}</Label></Menu.Item> :  
                (stat === 'Closed') ? <Menu.Item><strong style={{color: 'purple'}}>Closed</strong><Label>{countOfClosed}</Label></Menu.Item> : 
      ''),
      render: () => (
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Project Code</Table.HeaderCell>
              <Table.HeaderCell>Compay</Table.HeaderCell>
              <Table.HeaderCell>Ring Id</Table.HeaderCell>
              <Table.HeaderCell>State</Table.HeaderCell>
              <Table.HeaderCell>Site Id</Table.HeaderCell>
              <Table.HeaderCell>Site Name</Table.HeaderCell>
              <Table.HeaderCell>Upstream Site Id</Table.HeaderCell>
              <Table.HeaderCell>Upstream Site Name</Table.HeaderCell>
              <Table.HeaderCell width={1}>Action</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {transmissionsByDate.map(
              (transmission) => 
                transmission.status === stat && (
                  <Table.Row key={transmission.id}>
                    <Table.Cell>
                      <strong>{transmission.projectCode}</strong>
                    </Table.Cell>
                    <Table.Cell>{transmission.orderNumber}</Table.Cell>
                    <Table.Cell> {transmission.projectSite.ringId}</Table.Cell>
                    <Table.Cell> {transmission.projectSite.state}</Table.Cell>
                    <Table.Cell> 
                      <Link to={`/projectmanagement/sitevodafone?siteid=${transmission.projectSite.siteId}`} style={{ color: "blue" }}>
                      {transmission.projectSite.siteId}</Link>
                    </Table.Cell>
                    <Table.Cell>
                      {" "}
                      {transmission.projectSite.siteName}
                    </Table.Cell>
                    <Table.Cell>
                      {" "}
                      <Link to={`/projectmanagement/sitevodafone?siteid=${transmission.projectSite.upstreamSiteId}`} style={{ color: "blue" }}>
                      {transmission.projectSite.upstreamSiteId}</Link>
                    </Table.Cell>
                    <Table.Cell>
                      {" "}
                      {transmission.projectSite.upstreamSiteName}
                    </Table.Cell>
                    <Table.Cell>
                      <Button.Group size="mini">
                        <Button
                          as={Link}
                          to={`/projectmanagement/transmission/${transmission.id}`}
                          size="mini"
                          icon="zoom in"
                          color="blue"
                          title="View"
                        />
                        <Button
                          name={transmission.id}
                          size="mini"
                          loading={target === transmission.id && submitting}
                          //onClick={(e) => deleteTransmission(e, transmission.id)}
                          onClick={() => {
                            setOpen(true);
                            setTransmissionId(transmission.id);
                          }}
                          icon="delete"
                          color="red"
                          title="Delete"
                        />
                        <Confirm
                          open={open}
                          onCancel={() => setOpen(false)}
                          onConfirm={(e) => {
                            deleteTransmission(transmissionId);
                            setOpen(false);
                          }}
                          content="Are you sure you want to delete ?"
                          confirmButton="Yes"
                          size="mini"
                          style={{
                            position: "relative",
                            maxHeight: "150px",
                            height: "auto",
                          }}
                        />
                      </Button.Group>
                    </Table.Cell>
                  </Table.Row>
                )
            )}
          </Table.Body>
        </Table>
      ),
    };
  });

  return (
    <Container fluid>
      <Tab 
      panes={panes} 
      menu={{ pointing: true }} 
      onTabChange={(e, data) => setActiveListTab(Number(data.activeIndex))}
      defaultActiveIndex={activeListTab}
      />
    </Container>
  );
};

export default observer(TransmissionList);
